
















































































































import Vue from "vue";
import store from "@/store";
import firebaseApp from "@/main";
import { v4 as uuidv4 } from "uuid";

// ** Interfaces
import {
  AddNewExercise,
  ExerciseFirestore,
  formatExerciseId,
} from "@/interfaces/exercise.interface";
import { getNowInUnix } from "@/interfaces/time.interface";
import { ExerciseTemplate } from "@/interfaces/workoutTemplate.interface";
import { userData, userWorkoutTemplate } from "@/interfaces/user.interface";

export default Vue.extend({
  name: "SignUp",
  data: () => ({
    valid: false,
    overlayLoader: false,

    // UserName Validation
    userName: "",
    userNameRules: [
      (v: any) => !!v || "User Name is required",
      (v: any) => v.length <= 16 || "User Name must be less than 16 characters",
    ],

    // Email Validation
    email: "",
    emailRules: [
      (v: string) => !!v || "E-mail is required",
      (v: string) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    // Password Validation
    password: "",
    showPassword: false,
    passwordRules: {
      required: (value: string) => !!value || "Required.",
      min: (v: string) => v.length >= 6 || "Min 6 characters",
    },

    // Visibility
    visibility: "Public" || "Private" || "Friends Only",
    visibilityLabels: ["Public", "Friends Only", "Private"],

    // Description
    description: "",

    // Age
    age: 0,
    ageRules: {
      maxAge: (value: any) => value <= 120 || "Max 120 years",
      isNumber: (value: any) => /^\d+$/.test(value) || "Only Numbers",
    },

    // Weight
    weight: 0,
    weightRules: {
      maxWeight: (value: any) => value <= 1000 || "Max 1000 pounds",
      isNumber: (value: any) => /^\d+$/.test(value) || "Only Numbers",
    },

    // Profile Image
    profileImage: new Blob(),
    wantProfileImg: false,
    profileImageRules: [
      (value: Blob) =>
        !value ||
        value.size < 8000000 ||
        "Image size should be less than 8 MB!",
    ],
  }),
  methods: {
    async createUser() {
      this.overlayLoader = true;
      if (this.valid) {
        await this.isUserNameTaken().then(async (userNameTaken) => {
          if (userNameTaken) {
            this.overlayLoader = false;
            alert("User Name is taken");
          } else {
            if (
              this.visibility == "Public" ||
              this.visibility == "Private" ||
              this.visibility == "Friends Only"
            ) {
              // Create and Set UID with Firebase Auth
              await firebaseApp
                .auth()
                .createUserWithEmailAndPassword(this.email, this.password)
                .then(async (authResult) => {
                  store.commit("userStore/setUserUID", authResult.user?.uid);
                  let userUID: string = store.getters["userStore/getUserUID"];
                  const batch = firebaseApp.firestore().batch();
                  const userRef = firebaseApp
                    .firestore()
                    .collection("users")
                    .doc(userUID);

                  // If wants profile img, add to Firebase Storage and get DownloadURl
                  let imgUrl: string | null = null;
                  if (this.wantProfileImg) {
                    let profileImageUpload = firebaseApp
                      .storage()
                      .ref(`users/${userUID}/profileImage`);
                    await profileImageUpload.put(this.profileImage);

                    await profileImageUpload
                      .getDownloadURL()
                      .then((downloadUrl: string) => {
                        imgUrl = downloadUrl;
                      })
                      .catch((err) => {
                        console.error(err);
                      });
                  }

                  if (authResult.user)
                    await authResult.user
                      .updateProfile({
                        photoURL: imgUrl,
                        displayName: this.userName,
                      })
                      .catch(() => {
                        console.error("could not update ");
                      });

                  const fullBodyTemplate: userWorkoutTemplate = this.generateBaseWorkoutTemplate();
                  // Add userData to firestore
                  let userData: userData = {
                    userName: this.userName,
                    workoutTemplates: {
                      [fullBodyTemplate.id]: fullBodyTemplate,
                    },
                    customExercises: [],
                    favoriteExercises: [],
                    visibility: "Private",
                    dateJoined: getNowInUnix(),
                    age: this.age,
                    weight: this.weight,
                    description: this.description,
                    currentWorkout: null,
                  };

                  if (imgUrl) userData.profileImgUrl = imgUrl;

                  batch.set(userRef, userData);

                  // Sets standard exercises in users /exercise collection
                  const baseExercises: AddNewExercise[] =
                    store.getters["exerciseStore/getBaseExercises"];

                  baseExercises.forEach((exercise) => {
                    const exerciseName: string = formatExerciseId(
                      exercise.exerciseName,
                      exercise.type
                    );

                    let newExercise: ExerciseFirestore = {
                      exerciseName: exercise.exerciseName,
                      type: exercise.type,
                      bodyParts: exercise.bodyParts,
                      isCustomExercise: false,
                      datesDone: [],
                    };

                    batch.set(
                      userRef.collection("exercises").doc(exerciseName),
                      newExercise
                    );
                  });

                  store.commit("userStore/setUserData", userData);

                  // Adds userName to userName collection, and what type of visibility user has.
                  batch.set(
                    firebaseApp
                      .firestore()
                      .collection("userNames")
                      .doc(userData.userName),
                    {
                      belongsTo: userUID,
                      visibility: userData.visibility,
                    }
                  );

                  await batch
                    .commit()
                    .then(() => {
                      console.log("Everything went well");
                    })
                    .catch((err) => {
                      console.log(err);
                    });

                  await authResult.user?.sendEmailVerification().then(() => {
                    alert("Sent email verification ");
                  });

                  this.overlayLoader = false;
                })
                .catch((err) => {
                  if (err.code === "auth/email-already-in-use") {
                    alert(
                      "The email address is already in use. Please sign in or use a different email"
                    );
                  } else {
                    console.error(err);
                    alert("there was a problem on our side");
                  }
                  this.overlayLoader = false;
                });
            } else alert("TODO!!!");
          }
        });
      } else alert("Make sure your form is correct.");
    },
    changeProfileImage(event: any): void {
      if (event) {
        this.wantProfileImg = true;
        this.profileImage = event;
      } else {
        this.wantProfileImg = false;
        this.profileImage = new Blob();
      }
    },
    async isUserNameTaken() {
      let userNameTaken = false;
      let errorGettingName = false;
      let errData: any = {};
      await firebaseApp
        .firestore()
        .collection("userNames")
        .doc(this.userName)
        .get()
        .then((res) => {
          if (res.exists) userNameTaken = true;
        })
        .catch((err) => {
          errData = err;
          errorGettingName = true;
        });

      if (errorGettingName) return Promise.reject(errData);
      return Promise.resolve(userNameTaken);
    },
    generateBaseWorkoutTemplate(): userWorkoutTemplate {
      const Squat: ExerciseTemplate = {
        exerciseName: "Squat",
        bodyParts: ["Calves", "Legs", "Glutes"],
        type: "Barbell",
        sets: [
          { weight: 95, reps: 5 },
          { weight: 95, reps: 5 },
          { weight: 95, reps: 5 },
        ],
      };

      const BenchPress: ExerciseTemplate = {
        exerciseName: "Bench Press",
        bodyParts: ["Chest", "Triceps"],
        type: "Barbell",
        sets: [
          { weight: 85, reps: 5 },
          { weight: 85, reps: 5 },
          { weight: 85, reps: 5 },
        ],
      };

      const Deadlift: ExerciseTemplate = {
        exerciseName: "Deadlift",
        bodyParts: ["Lower Back", "Legs", "Hamstrings", "Glutes"],
        type: "Barbell",
        sets: [
          { weight: 85, reps: 5 },
          { weight: 85, reps: 5 },
          { weight: 85, reps: 5 },
        ],
      };

      const FullBodyTemplate: userWorkoutTemplate = {
        workoutName: "Full Body",
        lastDone: null,
        timesDone: 0,
        exercises: [Squat, BenchPress, Deadlift],
        templateOrderIdx: 0,
        dateCreated: getNowInUnix(),
        id: uuidv4(),
        datesDone: [],
      };

      return FullBodyTemplate;
    },
    routeToSignIn() {
      this.$router.push("/signIn");
    },
  },
  async mounted() {
    if (store.getters["userStore/isUserSignedIn"]) this.$router.push("/");
  },
});
